import { render, staticRenderFns } from "./chip.vue?vue&type=template&id=b7cee7f4&scoped=true&"
import script from "./chip.vue?vue&type=script&lang=js&"
export * from "./chip.vue?vue&type=script&lang=js&"
import style0 from "./chip.vue?vue&type=style&index=0&id=b7cee7f4&lang=scss&scoped=true&"
import style1 from "./chip.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cee7f4",
  null
  
)

/* custom blocks */
import block0 from "./chip.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports